import React from "react";
import { iconsPaths } from "./GPX/Resources";
import { useTranslation } from "react-i18next";

const copyTextWithFallback = (text) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);

  try {
    textarea.select();
    return document.execCommand("copy");
  } catch (error) {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
};

const ContextMenu = ({
  menuVisible,
  markerTypes,
  originMarker,
  destinationMarker,
  menuPosition,
  handleMenuItemClick,
  handleClickOutsideMap,
  setCopiedCoordinates,
  setShowInfoPointMenu,
  projectType,
}) => {
  const { t } = useTranslation();
  const touristicIconPath =
    iconsPaths.rootFolder + projectType + iconsPaths.Touristic;
  const standardIconPath =
    iconsPaths.rootFolder + projectType + iconsPaths.PI_standard;
  if (menuVisible)
    return (
      <div
        style={{
          position: "absolute",
          top: menuPosition.y + 100,
          left: menuPosition.x,
        }}
      >
        <button
          className="badge rounded-pill bg-danger col-2"
          onClick={() => handleClickOutsideMap}
        >
          <span>X</span>
        </button>
        <br />
        <button
          className="btn btn-success btn-sm col-12"
          onClick={() => handleMenuItemClick(markerTypes.origin)}
          disabled={Object.keys(originMarker).length === 0 ? false : true}
        >
          <span>🏁 {t("startRoute")}</span>
        </button>
        <br />
        <button
          className="btn btn-info btn-sm col-12"
          onClick={() => handleMenuItemClick(markerTypes.step)}
        >
          <span>📍{t("checkPoint")}</span>
        </button>
        <br />
        <button
          id="destination"
          className="btn btn-success btn-sm col-12"
          onClick={() => handleMenuItemClick(markerTypes.destination)}
          disabled={Object.keys(destinationMarker).length === 0 ? false : true}
        >
          <span>🏁 {t("endRoute")}</span>
        </button>
        <br />
        <button
          className="btn btn-danger btn-sm col-12"
          onClick={() => {
            handleMenuItemClick(markerTypes.touristic);
            setShowInfoPointMenu(false);
          }}
        >
          <img style={{ width: "25px" }} src={touristicIconPath} />{" "}
          <span>{t("touristicPI")}</span>
        </button>
        <br />
        <button
          className="btn btn-primary btn-sm col-12"
          onClick={() => {
            handleMenuItemClick(markerTypes.information);
            setShowInfoPointMenu(false);
          }}
        >
          <img style={{ width: "25px" }} src={standardIconPath} />{" "}
          <span>{t("standardPI")}</span>
        </button>
        <br />
        <button
          className="btn btn-warning btn-sm col-12"
          onClick={() => {
            const lat = menuPosition.lat.toFixed(8);
            const lng = menuPosition.lng.toFixed(8);
            const formattedCoordinates = `${lat}, ${lng}`;
            const markCoordinatesCopied = () => {
              setCopiedCoordinates(true);
              setTimeout(() => {
                setCopiedCoordinates(false);
              }, 3000);
            };

            if (navigator.clipboard?.writeText) {
              navigator.clipboard
                .writeText(formattedCoordinates)
                .then(markCoordinatesCopied)
                .catch(() => {
                  if (copyTextWithFallback(formattedCoordinates)) {
                    markCoordinatesCopied();
                  } else {
                    console.error("Impossible de copier les coordonnées GPS.");
                  }
                });
            } else if (copyTextWithFallback(formattedCoordinates)) {
              markCoordinatesCopied();
            } else {
              console.error("Impossible de copier les coordonnées GPS.");
            }
          }}
        >
          <span>{t("GPSCoord")}</span>
        </button>
      </div>
    );
};

export default ContextMenu;
